import React, {useContext, useEffect, useState} from 'react';
import {Form, useParams} from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    customToast, DisabledContext, FormInput,
    SubTitle, Title, Variants,
    WidthConstrainedContainer
} from "toolbox-react-frontend-components";
import LoadingPane from "../../../components/LoadingPane";
import {cloneDeep} from "lodash";

const EditPage = (props) => {
    const {

    } = props;

    const { page } = useParams();

    const {
        disabled,
        setDisabled
    } = useContext(DisabledContext);

    const [data, setData]                   = useState(null);
    const [loaded, setLoaded]               = useState(false);
    const [errors, setErrors]               = useState(null);
    const [submitting, setSubmitting]       = useState(false)

    useEffect(() => {
        loadPageData();
    }, []);

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const loadPageData = () => {
        axios.get(route('api.admin.page.get', {page: page}))
            .then((response) => {
                if (!!response && !!response.data) {
                    setData(response.data);
                    setLoaded(true);
                    setSubmitting(false);
                    setDisabled(false);
                } else {
                    customToast({
                        title:      'Page data not found. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const submit = () => {
        setDisabled(true);
        setErrors(null);

        axios.patch(route('api.admin.page.update', {page: page}), data)
            .then((response) => {
                customToast({
                    title:      'Page updated. Reloading...',
                    variant:    Variants.Success
                });

                loadPageData();
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title:      error.response.data.message,
                            variant:    Variants.Danger
                        });
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    setSubmitting(false);
                    setDisabled(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }

    const updateField = (fieldName, value) => {
        let clone = cloneDeep(data);

        clone.data[fieldName].value = value;

        setData(clone);
    }

    const renderPageName = (value) => {
        return value.replace(/_/g, ' ');
    }

    const formRenderer = () => {
        return Object.keys(data.data).map((key, index) => {
            let field = data.data[key];

            let label = renderPageName(key);
            label = label.charAt(0).toUpperCase() + label.slice(1);

            let fieldErrors = null;
            if (!!errors && !!errors['data.'+key+'.value']) {
                fieldErrors = errors['data.'+key+'.value'];
            }

            switch (field.type) {
                case 'textarea':
                case 'text':
                default:
                    return (
                        <FormInput
                            key={index}
                            type={field.type}
                            label={label}
                            name={key}
                            value={field.value}
                            errorMessages={fieldErrors}
                            onChange={(value) => updateField(key, value)}
                            disabled={submitting || disabled}
                        />
                    )
            }
        });
    }

    if (!loaded) {
        return (
            <LoadingPane />
        );
    }

    return (
        <WidthConstrainedContainer>
            <Card
                noMargin={true}
            >
                <CardHeader
                    leftSlot={(
                        <>
                            <Title title={'Edit page: '}/>
                            <SubTitle
                                title={renderPageName(data.name)}
                                noMargin={true}
                            />
                        </>
                    )}
                />
                <CardBody>
                    {formRenderer()}
                    <div className={'d-flex align-items-center justify-content-end'}>
                        <Button
                            label={submitting ? 'Updating...' : 'Update'}
                            onClick={(event) => setSubmitting(true)}
                            disabled={submitting || disabled}
                        />
                    </div>
                </CardBody>
            </Card>
        </WidthConstrainedContainer>
    );
}

export default EditPage;
